module.exports = __webpack_public_path__ + "static/media/teygja_innanverdlaeri_small.3ccb1384.png";